import { createFileRoute } from "@tanstack/react-router";
import { VaerdictCasePage } from "@/components/blocks/work/VaerdictCasePage";
import {
	buildPageBreadcrumb,
	buildPageSeo,
	loadPageLocale,
} from "@/lib/page-seo";

export const Route = createFileRoute("/{-$locale}/realisations/vaerdict")({
	component: VaerdictCasePage,
	loader: loadPageLocale,
	head: ({ loaderData }) =>
		loaderData
			? buildPageSeo("vaerdictCase", loaderData.locale, {
					structuredData: [
						buildPageBreadcrumb(loaderData.locale, ["work", "vaerdictCase"]),
					],
				})
			: {},
});
